import { message } from "ant-design-vue";

const isUrl = function(str) {
  return /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/.test(
    str
  );
};
const getDate = function(date) {
  if (date) {
    let arr = date.split(/[-:\s]/);
    arr = arr.concat(new Array(6 - arr.length).fill(0));
    arr[1] = arr[1] && arr[1] > 0 ? arr[1] - 1 : 0;
    return new Date(...arr);
  } else {
    return null;
  }
};

const getSuffix = function(filename) {
  let pos = filename.lastIndexOf(".");
  let suffix = "";
  if (pos != -1) {
    suffix = filename.substring(pos);
  }
  return suffix;
};
const isArray = function(arr) {
  return Object.prototype.toString.call(arr) === "[object Array]";
};
const isEmpty = function(str) {
  return str === undefined || str === null || str === "" || str === false;
};
const randomString = function(len) {
  len = len || 32;
  let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  let maxPos = chars.length;
  let pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};
const downLoadFile = function(url, fileName) {
  let eleLink = document.createElement("a");
  eleLink.download = fileName;
  eleLink.style.display = "none";
  eleLink.target = "_blank";
  eleLink.href = url;
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
};


const downLoadBlobFile = function(content, fileName) {
  const blob = new Blob([content]);
  if ("download" in document.createElement("a")) {
    // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName + ".xlsx";
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
};

const clone = function(obj) {
  let o;
  switch (typeof obj) {
    case "undefined":
      break;
    case "string":
      o = obj + "";
      break;
    case "number":
      o = obj - 0;
      break;
    case "boolean":
      o = obj;
      break;
    case "object":
      if (obj === null) {
        o = null;
      } else {
        if (obj instanceof Array) {
          o = [];
          for (let i = 0, len = obj.length; i < len; i++) {
            o.push(clone(obj[i]));
          }
        } else if (obj instanceof Date) {
          o = new Date(obj);
        } else {
          o = {};
          for (let k in obj) {
            o[k] = clone(obj[k]);
          }
        }
      }
      break;
    default:
      o = obj;
      break;
  }
  return o;
};

const getDistance = function(config) {
  if (!config) return null;
  let { top, right, bottom, left } = config;
  top = top || 0;
  right = right || 0;
  bottom = bottom || 0;
  left = left || 0;
  return `${top}px ${right}px ${bottom}px ${left}px`;
};
const formatBooleanText = function(row, column, cellValue) {
  return cellValue == 1 ? "是" : "否";
};

const hotelFormatter = function(row, column, cellValue) {
  let res = "";
  if (cellValue) {
    try {
      res = JSON.parse(cellValue).address;
    } catch (e) {
      console.log(e);
    }
  }
  return res;
};

const getVolume = function(item) {
  if (item.length && item.width && item.height) {
    let vol =
      ((((item.length / 1000) * item.width) / 1000) * item.height) / 1000;
    return Math.round(vol * 10000) / 10000;
  } else {
    return "";
  }
};

const filterOption = function(input, option) {
  return (
    option.componentOptions.children[0].text
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
  );
};

const getFileSizeText = function(size) {
  let kb = 1024,
    mb = 1024 * 1024,
    gb = 1024 * 1024 * 1024;
  if (size < kb) {
    return `${size}B`;
  } else if (size < mb) {
    return `${Math.round(size / kb)}K`;
  } else if (size < gb) {
    return `${Math.round(size / mb)}M`;
  } else {
    return `${Math.round(size / gb)}G`;
  }
};

const getUrlFileName = function(url) {
  let index = url.lastIndexOf("/");
  if (index >= 0) {
    return url.substr(index + 1);
  } else {
    let str = randomString(6);
    index = url.lastIndexOf(".");
    if (index >= 0) {
      return str + url.substr(index);
    } else {
      return str;
    }
  }
};

const goToDetailRoute = function(vm, options) {
  vm.$store.commit("setDetail", { type: options.type, obj: options.item });
  vm.$router.push({
    name: "EntityDetail",
    params: { type: options.type, id: options.item.id },
    query: options.edit ? { edit: "1" } : {},
  });
};

const getDurationText = function(s) {
  let res = "",
    h = 60 * 60,
    m = 60;
  if (s >= h) {
    res = Math.floor(s / h) + "小时" + getDurationText(s % h);
  } else if (s >= m) {
    res = Math.floor(s / m) + "分钟" + getDurationText(s % m);
  } else if (s > 0) {
    res = s + "秒";
  }
  return res;
};
const getTimePeriod = function(startTime, endTime) {
  let res = null;
  if (startTime && endTime) {
    let start = getDate(startTime);
    let end = getDate(endTime);
    let sd = start.pattern("yyyy-MM-dd"),
      st = start.pattern("HH:mm");
    let ed = end.pattern("yyyy-MM-dd"),
      et = end.pattern("HH:mm");
    if (sd == ed) {
      res = `${sd} ${st} - ${et}`;
    } else {
      res = `${sd} ${st} 至 ${ed} ${et}`;
    }
  }
  return res;
};
const getDoubleText = function(num) {
  return num < 10 ? "0" + num : num;
};
/**
 * 根据常量值获取常量名称
 * @param list 常量列表数组
 * @param value 常量值
 * @param valKey 常量值key
 * @param nameKey 常量名称key
 * **/
const getKeyTitle = function(list, value, valKey = "key", nameKey = "title") {
  let res = null;
  if (list) {
    res = list.find((item) => item[valKey] == value);
  }
  return res ? res[nameKey] : "";
};

const getRadioOptionsFromSelect = function(options) {
  return options.map((opt) => {
    return {
      label: opt.title,
      value: opt.key,
    };
  });
};

// 获取圆环上某点的坐标
const getPoint = function(x, y, r, angle) {
  let pi = (Math.PI * angle) / 180;
  let rx = x + r * Math.cos(pi);
  let ry = y - r * Math.sin(pi);
  return { x: rx, y: ry };
};

const printDom = function(dom, style) {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("style", "display:none;border:none;");
  document.body.appendChild(iframe);
  const subWindow = iframe.contentWindow;
  subWindow.document.body.setAttribute("style", "margin:0;");
  if (style) {
    console.log(style);
    subWindow.document.head.append(style);
  }
  let box = dom.cloneNode(true);
  subWindow.document.body.append(box);
  setTimeout(() => {
    subWindow.print();
    document.body.removeChild(iframe);
  }, 100);
};

/**
 * 数字转换中文大写
 * @param n
 * @return {string}
 */
const numberToText = function(n) {
  if (n === 0) return "零";
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "";
  let unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
    str = "";
  n += "00";
  let p = n.indexOf(".");
  if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
  unit = unit.substr(unit.length - n.length);
  for (let i = 0; i < n.length; i++)
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
  return str
    .replace(/零(仟|佰|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|元)/g, "$1")
    .replace(/(亿)万/g, "$1$2")
    .replace(/^元零?|零分/g, "")
    .replace(/元$/g, "元整");
};
const omit = (obj, uselessKeys) =>
  Object.keys(obj).reduce(
    (acc, key) =>
      uselessKeys.includes(key) ? acc : { ...acc, [key]: obj[key] },
    {}
  );

const getPrefixName = function(filename) {
  let pos = filename.lastIndexOf(".");
  let prefix = "";
  if (pos != -1) {
    prefix = filename.substring(0, pos);
  }
  return prefix;
};

const copy = function(url) {
  let input = document.createElement("input");
  document.body.appendChild(input);
  input.setAttribute("value", url);
  input.select();
  if (document.execCommand("copy")) {
    document.execCommand("copy");
    message.success("已复制");
  }
  document.body.removeChild(input);
};

// immediate： 是否立即执行回调函数; 其它参数同上
const debounce = function(fn, wait, immediate) {
  let timer = null;
  return function() {
    let args = [].slice.call(arguments);
    if (immediate && !timer) {
      fn.apply(this, args);
    }
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      //箭头函数，this指向外层环境
      fn.apply(this, args);
    }, wait);
  };
};

export {
  isUrl,
  getDate,
  getSuffix,
  randomString,
  downLoadFile,
  downLoadBlobFile,
  clone,
  getDistance,
  isEmpty,
  isArray,
  formatBooleanText,
  hotelFormatter,
  getVolume,
  filterOption,
  getUrlFileName,
  goToDetailRoute,
  getDurationText,
  getTimePeriod,
  getDoubleText,
  getFileSizeText,
  getKeyTitle,
  getRadioOptionsFromSelect,
  getPoint,
  printDom,
  numberToText,
  omit,
  getPrefixName,
  copy,
  debounce,
};
